import React, { useEffect, useState, useContext } from 'react';
import Card from '../../components/card.component';
import functions from './facturacion.functions';
import DataTable from 'react-data-table-component';
import table from './facturacion.table';
import DataTableExtensions from 'react-data-table-component-extensions';
import { ConfigContextUtils } from '../../context/contextUtils.context';
import { ConfigContext } from '../../context/config.context';
import TabsTitleButttons from './components/tabsTitleButttons';

const SALES_TYPE = 'VN';

const BoletaListado = () => {

   const { config } = useContext(ConfigContext);
   const { setPreloader } = useContext(ConfigContextUtils);
   const [data, setData] = useState([]);
   const [typeDocument, setTypeDocument] = useState(SALES_TYPE);

   useEffect(() => {
      const getListadoBoletas = () => {
        setPreloader(true);
        functions.listado(typeDocument).then((response) => {
            setData(response);
            setPreloader(false);
        });
      }
      getListadoBoletas();
      // eslint-disable-next-line 
   },[typeDocument]);

   const updateColummnBol = (id) => {
      const updateValues = [...data];
      const indexof = data.findIndex(val => val.id === id);
      updateValues[indexof].estado = 0;
      setData(updateValues);
   }

   const changeTypeComercialDocument = (value) => {
      setTypeDocument(value);
   }

  return (
    <Card>
        <TabsTitleButttons
          onChange={(value) => changeTypeComercialDocument(value)}
        />
        <DataTableExtensions
           columns={table.boletas(updateColummnBol, config.prefijo_correlativo_guia)}
           data={data}
           export={false}
           print={false}
           filterPlaceholder="Filtrar recibo de pago"
        >
            <DataTable
              noHeader={true}
              customStyles={table.customStyles}
              dense={true}
              noDataComponent={'No existen recibos de pagos registrados'}
              conditionalRowStyles={table.conditionalRowBoleta}
              pagination={true}
              paginationPerPage={30}
            />
        </DataTableExtensions>
    </Card>
  )
}

export default BoletaListado;